import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';


Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});


const funded = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Tours/Sightseeing', 'Shopping', 'Recreation', 'Information technology', 'Financial services', 'Business and industry', 'Mobile platforms', 'Gaming', 'E-commerce', 'Transportation and logistics']
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Amount invested ($M USD)'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Funding amount ($M USD)',
        data: [153, 122, 233, 188, 107, 340, 105, 557, 2112, 2761]
    }]
}



export class ChapterFortyThree extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>
        <TextHolder text="The survey confirmed the general view that the twins of the consumer internet economy, logistics and e-commerce, dominate the regional tech startup industry. About three-quarters of all funding went to e-commerce and logistics startups in 2017." />
        <TextHolder text="Grab’s and Tokopedia’s record-breaking venture deals can also be attributed to the dominance of these two sectors. Collectively, they raised $3.1 billion in funding, which is almost two-thirds of all funding dollars for e-commerce and logistics and almost half of all funding dollars overall." />

        <TextHolder text="" />



        <Highchartscomponent   chartsText="Top 10 highest funded categories in SEA (2017)" options={funded} source={<p>Source: <a href="https://www.funderbeam.com">Funderbeam</a>, Slush Singapore analysis</p>} chartsBottomText="The darling of the VC community in recent years had been cryptocurrency, leading to many ICO (initial coin offering) deals in SEA. Singapore dominated the top ICO investments in 2017, with Quoine, TenX, and Kyber Network in the top three positions, raising the equivalent of $105 million, $80 million and $60 million respectively. Tough ICO trading rules in China and South Korea prompted foreign startups to look outside those countries. Many landed in Singapore to hold their ICOs."/>

        <TextHolder textTitle="Top ICO investments in 2017" />

        <div className="block-outer block-outer-tableholder">
          <div className="block-inner block-inner-tableholder">
            <table id="t01">
            <tbody>
              <tr>
                <th>Company name</th>
                <th>Country HQ</th>
                <th>Date of investment</th>
                <th>Amount ($ USD)</th>
              </tr>
              <tr>
                <td>Quoine</td>
                <td>Singapore</td>
                <td>Q4 2017</td>
                <td>$ 105,000,000</td>
              </tr>
              <tr>
                <td>TenX</td>
                <td>Singapore</td>
                <td>Q2 2017</td>
                <td>$ 83,110,000</td>
              </tr>
              <tr>
                <td>Kyber Network</td>
                <td>Singapore</td>
                <td>Q3 2017</td>
                <td>$ 53,010,000</td>
              </tr>
              <tr>
                <td>OmiseGO</td>
                <td>Thailand</td>
                <td>Q2 2017</td>
                <td>$ 25,000,000</td>
              </tr>
              <tr>
                <td>FinShi Capital</td>
                <td>Singapore</td>
                <td>Q3 2017</td>
                <td>$ 21,400,000</td>
              </tr>
              <tr>
                <td>QtumOfficial</td>
                <td>Singapore</td>
                <td>Q1 2017</td>
                <td>$ 15,600,000</td>
              </tr>
              <tr>
                <td>Indorse</td>
                <td>Singapore</td>
                <td>Q3 2017</td>
                <td>$ 7,980,000</td>
              </tr>
              <tr>
                <td>TaaS</td>
                <td>Singapore</td>
                <td>Q2 2017</td>
                <td>$ 7,570,000</td>
              </tr>
              <tr>
                <td>Coss</td>
                <td>Singapore</td>
                <td>Q3 2017</td>
                <td>$ 2,360,000</td>
              </tr>
              <tr>
                <td>FundYourselfNow</td>
                <td>Singapore</td>
                <td>Q3 2017</td>
                <td>$ 740,000</td>
              </tr>
              </tbody>
            </table>
            <div className="highcharts-notes">
              <p>Source: <a href="https://www.funderbeam.com">Funderbeam</a></p>
            </div>
        </div>
      </div>



  

      <div className="block-outer block-outer-tableholder">
        <div className="block-inner block-inner-tableholder">
          <table id="t01">
          <tbody>
            <tr>
              <th>2017 total</th>
              <th>2018 total (as of June 2018)</th>
            </tr>
            <tr>
              <td>$ 415.2M</td>
              <td>$ 53.8M</td>
            </tr>

            </tbody>
          </table>
      </div>
    </div>

          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/43.js